export function checkIfValidDate(
    birthYear?: string,
    birthMonth?: string,
    birthDay?: string
): boolean {
    if (!validateDateOfBirthComponents(birthYear, birthMonth, birthDay)) {
        return false;
    }

    const dateOfBirth = `${ birthYear as string }-${ birthMonth as string }-${ birthDay as string }`;

    if (isNaN((new Date(dateOfBirth)).getTime())) {
        return false;
    }

    return true;
}

export function checkIfUnder18(
    birthYear: undefined | string,
    birthMonth: undefined | string,
    birthDay: undefined | string
): boolean {
    if (!validateDateOfBirthComponents(birthYear, birthMonth, birthDay)) {
        return false;
    }

    const dateOfBirth = `${ birthYear as string }-${ birthMonth as string }-${ birthDay as string }`;
    const birthDate = new Date(dateOfBirth);
    const eighteenYearsAgo = new Date();

    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

    return birthDate.getTime() > eighteenYearsAgo.getTime();
}

export function validateDateOfBirthComponents(
    birthYear: undefined | string,
    birthMonth: undefined | string,
    birthDay: undefined | string
): boolean {
    if (!birthYear || !birthMonth || !birthDay) {
        return false;
    }

    if (birthYear.length !== 4) {
        return false;
    }

    return true;
}

export default {
    checkIfValidDate,
    checkIfUnder18,
    validateDateOfBirthComponents
};
